"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DragColActionWrapper = exports.DragColActionIcon = void 0;
exports.DragColIcon = DragColIcon;
exports.DragColTitle = void 0;
exports.DragRowIcon = DragRowIcon;
exports.DragRowNumber = DragRowNumber;
var _react = _interopRequireDefault(require("react"));
var _ykbStyledComponents = require("../../ykb-styled-components");
var _Icon = _interopRequireDefault(require("../../Icon"));
var IconWrapper = _ykbStyledComponents.styled.div.withConfig({
  componentId: "ykb-ui__sc-to0fd2-0"
})(["display:inline-block;"]);
var DragHandler = _ykbStyledComponents.styled.div.withConfig({
  componentId: "ykb-ui__sc-to0fd2-1"
})(["position:absolute;left:0px;top:0px;height:100%;width:", "px;justify-content:center;align-items:center;display:flex;cursor:pointer;:hover{background-color:", ";}"], function (props) {
  return props.theme.table.draggable.column.icon.width;
}, function (props) {
  return props.theme.table.draggable.column.icon.hover.backgroundColor;
});
var IconCentered = (0, _ykbStyledComponents.styled)(_Icon.default).withConfig({
  componentId: "ykb-ui__sc-to0fd2-2"
})(["vertical-align:middle;text-align:center;"]);
var RowOrderWrapper = _ykbStyledComponents.styled.div.withConfig({
  componentId: "ykb-ui__sc-to0fd2-3"
})(["text-align:center;"]);
var DragColActionWrapper = exports.DragColActionWrapper = _ykbStyledComponents.styled.span.withConfig({
  componentId: "ykb-ui__sc-to0fd2-4"
})(["position:absolute;top:0;right:0;height:100%;"]);
var DragColActionIcon = exports.DragColActionIcon = _ykbStyledComponents.styled.span.withConfig({
  componentId: "ykb-ui__sc-to0fd2-5"
})(["display:inline-flex;align-items:center;justify-content:center;width:", "px;height:100%;cursor:pointer;:hover{background-color:", ";}"], function (props) {
  return props.theme.table.draggable.column.icon.width;
}, function (props) {
  return props.theme.table.draggable.column.icon.hover.backgroundColor;
});
function DragColIcon() {
  return /*#__PURE__*/_react.default.createElement(IconWrapper, null, /*#__PURE__*/_react.default.createElement(DragHandler, {
    className: "dragHandler"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: 'grip-vertical',
    size: 18
  })));
}
function DragRowIcon() {
  return /*#__PURE__*/_react.default.createElement(IconCentered, {
    name: 'grip-vertical',
    size: 18
  });
}
function DragRowNumber(item, k, index) {
  return /*#__PURE__*/_react.default.createElement(RowOrderWrapper, null, index + 1);
}
var DragColTitle = exports.DragColTitle = _ykbStyledComponents.styled.span.withConfig({
  componentId: "ykb-ui__sc-to0fd2-6"
})(["display:inline-flex;margin-right:", "px;margin-left:", "px;"], function (props) {
  return props.$marginRight > 0 ? props.$marginRight - 6 : 0;
}, function (props) {
  return props.$marginLeft > 0 ? props.$marginLeft - 6 : 0;
});